/**
 * CONSTANTS for use in calcs and display.
 */
export const CONSTANTS = {
    copyYear: 2026,                     // current COPYRIGHT year of tool (update annually)
    currentYear: 2026,                  // current year of tool ***FOR CALCULATIONS*** (update annually)
    HSA_SINGLE: 4400,                   // HSA IRS limit single (update annually)
    HSA_FAMILY: 8750,                   // HSA IRS limit family (update annually)
    HSA_CATCHUP: 1000,                  // HSA IRS catchup amount (update annually)
    HSA_CATCHUP_AGE: 55,                // HSA IRS catchup age
    RETIREMENT_NEED: 315000,            // retirement need for family
    RETIREMENT_NEED_SINGLE_F: 172500,   // retirement need for single (female)
    RETIREMENT_NEED_SINGLE_M: 172500,   // retirement need for single (male)
    SPEND_SAVE_PCT: 50,                 // percent to determine spender vs saver
    ALTERNATE_CONTRIB_PCT: 10,          // percent recommendation for alternate HSA contrib amounts
    ALTERNATE_SPEND_PCT: 10,            // percent recommendation for alternate HSA spend amounts
    ALTERNATE_DOLLAR: 100,              // dollar amount recommendation for non-contributors
    SLIDER_STEP: 1,                    // step for HSA slider
    stateTaxOptions : [ 
            {state: 'AL', rate: 5.00},
            {state: 'AK', rate: 0.00},
            {state: 'AZ', rate: 2.50},
            {state: 'AR', rate: 4.70},
            {state: 'CA', rate: 8.00},
            {state: 'CO', rate: 4.40},
            {state: 'CT', rate: 5.00},
            {state: 'DC', rate: 8.50},
            {state: 'DE', rate: 6.60},
            {state: 'FL', rate: 0.00},
            {state: 'GA', rate: 5.19},
            {state: 'HI', rate: 7.20},
            {state: 'ID', rate: 5.30},
            {state: 'IL', rate: 4.95},
            {state: 'IN', rate: 2.95},
            {state: 'IA', rate: 3.80},
            {state: 'KS', rate: 5.70},
            {state: 'KY', rate: 4.00},
            {state: 'LA', rate: 3.00},
            {state: 'ME', rate: 5.80},
            {state: 'MD', rate: 5.75},
            {state: 'MA', rate: 5.00},
            {state: 'MI', rate: 4.25},
            {state: 'MN', rate: 6.80},
            {state: 'MS', rate: 4.40},
            {state: 'MO', rate: 4.95},
            {state: 'MT', rate: 5.90},
            {state: 'NE', rate: 5.20},
            {state: 'NV', rate: 0.00},
            {state: 'NH', rate: 0.00},
            {state: 'NJ', rate: 6.37},
            {state: 'NM', rate: 4.90},
            {state: 'NY', rate: 5.85},
            {state: 'NC', rate: 4.25},
            {state: 'ND', rate: 2.20},
            {state: 'OH', rate: 3.50},
            {state: 'OK', rate: 4.75},
            {state: 'OR', rate: 9.00},
            {state: 'PA', rate: 3.07},
            {state: 'RI', rate: 4.75},
            {state: 'SC', rate: 6.50},
            {state: 'SD', rate: 0.00},
            {state: 'TN', rate: 0.00},
            {state: 'TX', rate: 0.00},
            {state: 'UT', rate: 4.50},
            {state: 'VT', rate: 6.60},
            {state: 'VA', rate: 5.75},
            {state: 'WA', rate: 0.00},
            {state: 'WV', rate: 5.12},
            {state: 'WI', rate: 5.30},
            {state: 'WY', rate: 0.00}

        ]
};
